var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('ai-tutor',{attrs:{"config":_vm.config,"fullname":_vm.fullname,"username":_vm.username,"grade":_vm.grade,"metadata":_vm.metadata,"fullscreen":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }